import { render, staticRenderFns } from "./consumptionCode.vue?vue&type=template&id=64637f90&scoped=true"
import script from "./consumptionCode.vue?vue&type=script&lang=js"
export * from "./consumptionCode.vue?vue&type=script&lang=js"
import style0 from "./consumptionCode.vue?vue&type=style&index=0&id=64637f90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64637f90",
  null
  
)

export default component.exports